(function () {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function parseTarget(str) {
    if (!str) return NaN;
    const t = new Date(str.replace(/-/g, '/')).getTime();
    return t;
  }

  class HfCounter {
    constructor(el) {
      this.el = el;
      this.target = parseTarget(el.dataset.target);
      this.units = {
        days: el.querySelector('[data-num="days"]'),
        hours: el.querySelector('[data-num="hours"]'),
        minutes: el.querySelector('[data-num="minutes"]'),
        seconds: el.querySelector('[data-num="seconds"]'),
      };
      this.blocks = {
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]'),
      };
      this.seps = {
        afterDays: el.querySelector('[data-sep="after-days"]'),
        afterHours: el.querySelector('[data-sep="after-hours"]'),
        afterMinutes: el.querySelector('[data-sep="after-minutes"]'),
      };
      this.interval = null;
      this.start();
    }

    start() {
      if (isNaN(this.target)) {
        this.expire();
        return;
      }
      this.tick();
      this.interval = setInterval(() => this.tick(), SECOND);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    expire() {
      this.el.dataset.state = 'expired';
      this.stop();
    }

    tick() {
      const distance = this.target - Date.now();
      if (distance <= 0) {
        Object.values(this.units).forEach((n) => n && (n.textContent = '00'));
        this.expire();
        return;
      }

      const days = Math.floor(distance / DAY);
      const hours = Math.floor((distance % DAY) / HOUR);
      const minutes = Math.floor((distance % HOUR) / MINUTE);
      const seconds = Math.floor((distance % MINUTE) / SECOND);

      if (this.units.days) this.units.days.textContent = pad(days);
      if (this.units.hours) this.units.hours.textContent = pad(hours);
      if (this.units.minutes) this.units.minutes.textContent = pad(minutes);
      if (this.units.seconds) this.units.seconds.textContent = pad(seconds);

      const hideDays = days === 0;
      const hideHours = hideDays && hours === 0;
      const hideMinutes = hideHours && minutes === 0;

      this.toggle(this.blocks.days, hideDays);
      this.toggle(this.seps.afterDays, hideDays);
      this.toggle(this.blocks.hours, hideHours);
      this.toggle(this.seps.afterHours, hideHours);
      this.toggle(this.blocks.minutes, hideMinutes);
      this.toggle(this.seps.afterMinutes, hideMinutes);
    }

    toggle(el, hidden) {
      if (!el) return;
      if (hidden) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    }
  }

  const instances = new WeakMap();

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-hf-counter]').forEach((el) => {
      if (instances.has(el)) return;
      instances.set(el, new HfCounter(el));
    });
  }

  function destroy(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-hf-counter]').forEach((el) => {
      const inst = instances.get(el);
      if (inst) {
        inst.stop();
        instances.delete(el);
      }
    });
  }

  function deferInit(scope) {
    const run = () => init(scope);
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => deferInit());
  } else {
    deferInit();
  }

  document.addEventListener('shopify:block:load', (e) => deferInit(e.target));
  document.addEventListener('shopify:block:unload', (e) => destroy(e.target));
  document.addEventListener('shopify:section:load', (e) => deferInit(e.target));
  document.addEventListener('shopify:section:unload', (e) => destroy(e.target));
})();
